import React, {Component} from 'react';
import './index.css'
import BsyTurnPage from "../BsyTurnPage";
import { BsyUtils } from '../../utils/Utils';
import { dayjsUtils } from '../../utils/dayjsUtils';

class BsyModulesLog extends Component {
    state = {
        list:[],
        limit: 4,
        skip: 0,
        count: 0,
    }

    componentDidMount() {
        this.loadLog()
    }

    skipChange =(e)=>{
        this.setState({
            skip:e
        },()=>{
            this.loadLog()
        })
    }

    loadLog = () =>{
        const {limit, skip} = this.state
        React.axios("/module/module_log",{
            id: this.props.id,
            limit: limit,
            skip: limit * skip,
        }).then((res)=>{
            this.setState({list:res.data.log,count:res.data.count})
        })
    }

    listLimitChange = (e) => {
        // console.log('listLimitChange', e)
        this.setState({
            skip: 0,
            limit: e,
            loadMode: 'goPage',
        }, () => {

            this.loadLog()
        })
    }

    render() {
        const {list, skip, limit, count} = this.state
        return (
            <div className="BsyModulesLog">
                <div className="moduleLog">
                    {
                        list.map((val)=>{
                            return <div className="logItem"><p className="titleTime">{BsyUtils.date2Str(dayjsUtils.timeToTZ(val.releaseTime), "yyyy-MM-dd HH:mm:ss")}</p><p
                                className="version">{React.language('flow.version.label')+val.version}</p>
                                <div className="logCon"><p className="contentItem">{val.updateLog}</p></div>
                            </div>
                        })
                    }
                </div>
                <div className="log-page">
                    <BsyTurnPage noLimitBtn={true} listLimitChange={this.listLimitChange} skipChange={this.skipChange} limit={limit} skip={skip} count={count} />
                </div>
            </div>
        );
    }
}

export default BsyModulesLog;